// extracted by mini-css-extract-plugin
module.exports = {"container":"warping-horizon_container__2h86o","container1":"warping-horizon_container1__1syYB","text":"warping-horizon_text__1rEz4"};